module.exports = __webpack_public_path__ + "img/az.403e9b3f.svg";